'use client';

import Icon from '@/components/Icon';
import { mittInstance } from '@/constants/mitt-instance';
import { useToasts } from '@/hooks/Toasts/useToasts';
import { useEffect } from 'react';
import { AlertCircle as AlertCircleIcon } from 'react-feather';

const errorIcon = (
  <Icon
    src={AlertCircleIcon}
    size={20}
  />
);

/**
 * 统一处理接口的网络层故障（CDN 拦截、限流、服务端异常、断网）。
 * 这类失败刷新后通常就能恢复，所以给一个可手动刷新的提示，
 * 而不是让错误继续往上抛、最终被 error boundary 变成一个 404 页面。
 */
const NetworkErrorToast = () => {
  const [, { addToast }] = useToasts() as any;

  useEffect(() => {
    const handleNetworkError = () => {
      // 断网时让用户先查网络，否则一味让人刷新只会更让人困惑
      const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;

      addToast({
        type: 'error',
        icon: errorIcon,
        message: isOffline
          ? "Looks like you're offline. Please check your connection, then refresh."
          : "Oops! This page didn't load properly. A quick refresh should fix it.",
        actionText: 'Refresh',
        onAction: () => {
          window.location.reload();
        },
        dismissable: true,
        timeout: false,
      });
    };

    mittInstance.on('NETWORK_ERROR', handleNetworkError);

    return () => {
      mittInstance.off('NETWORK_ERROR', handleNetworkError);
    };
  }, [addToast]);

  return null;
};

export default NetworkErrorToast;
